import { Create, SimpleForm, useNotify, useRedirect } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";

import BaseForm from "./BaseForm";
import { useState } from "react";
import { CircularProgress } from "@mui/material";
import { getStyle } from "customStyles/utils";
import { settings } from "app";
import { EVENTS } from "utils/constants";

const CreateAlumniEvent = () => {
  const [eventLogoImageId, setEventLogoImageId] = useState(null);
  const [isDisableEventUpload, setIsDisableEventUpload] = useState(false);
  const [loadingSend, setLoadingSend] = useState(false);
  const redirect = useRedirect();
  const notify = useNotify();
  const style = getStyle(settings.tenant);

  const convertData = (obj, keysToRemove = [], prefixesToRemove = []) => {
    const removedData = Object.fromEntries(
      Object.entries(obj)
        .filter(([key]) => !keysToRemove.includes(key) && !prefixesToRemove.some(prefix => key.startsWith(prefix)))
        .map(([key, value]) => {
          const dateKeys = ["startsAt"];

          if (typeof value === "string" && dateKeys.includes(key)) {
            value = value.split("T")[0];
          }

          return [key, value];
        }),
    );

    return removedData;
  };
  const handleSend = data => {
    setLoadingSend(true);

    return {
      ...convertData(data, ["imageId"], ["imageId_"]),
      imageId: eventLogoImageId,
    };
  };

  return (
    <div style={loadingSend ? { opacity: 0.5 } : { opacity: 1 }}>
      {loadingSend && (
        <div style={style.loadingStyle.container}>
          <CircularProgress size={200} />
          <div style={style.loadingStyle.text}>Saving...</div>
        </div>
      )}
      <Create
        title="Създаване на събитие"
        actions={<BackButtonToolbar />}
        transform={handleSend}
        mutationOptions={{
          onSuccess: data => {
            setLoadingSend(false);
            redirect(`/${EVENTS}`);
          },
          onError: error => {
            console.error(error);

            setLoadingSend(false);
            notify(error.message, { type: "error" });
          },
        }}
      >
        <SimpleForm>
          <BaseForm
            setEventLogoImageId={setEventLogoImageId}
            isDisableEventUpload={isDisableEventUpload}
            setIsDisableEventUpload={setIsDisableEventUpload}
          />
        </SimpleForm>
      </Create>
    </div>
  );
};

export default CreateAlumniEvent;
